import React from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";

function ThankYou() {
    return (
        <>
            <Header />
            <input
                type="hidden"
                id="care-giver-id-rating"
                className="careGiverIdRating"
            />
            <input
                type="hidden"
                id="care-giver-jobId-rating"
                className="careGiverJobIdRating"
            />
            <input
                type="hidden"
                id="care-giver-userId-rating"
                className="careGiverUserIdRating"
            />
            <section className="jobs">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div>
                                <h4 className="blue">
                                    <i
                                        className="fa fa-check-circle greenbg"
                                        aria-hidden="true"
                                    ></i>
                                    Thank you for Payment{" "}
                                </h4>
                                <p>
                                    Payment has been made Successfully | You
                                    have paid <b></b>{" "}
                                    <a className="giver-name" href="#"></a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row py-2">
                        <div className="col-md-8">
                            <form id="submit-giver-feedback">
                                <h4 className="blue">Review and Feedback</h4>
                                {/* <!--                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore</p>--> */}
                                <div className="d-flex py-3">
                                    <p>Rate Out of 5</p>
                                    <div className="rating-stars">
                                        <input
                                            type="radio"
                                            className="rating-star-feedback"
                                            id="star5"
                                            name="rate"
                                            value="5"
                                        />
                                        <label htmlFor="star5" title="text">
                                            {" "}
                                            stars
                                        </label>
                                        <input
                                            type="radio"
                                            className="rating-star-feedback"
                                            id="star4"
                                            name="rate"
                                            value="4"
                                        />
                                        <label htmlFor="star4" title="text">
                                            {" "}
                                            stars
                                        </label>
                                        <input
                                            type="radio"
                                            className="rating-star-feedback"
                                            id="star3"
                                            name="rate"
                                            value="3"
                                        />
                                        <label htmlFor="star3" title="text">
                                            {" "}
                                            stars
                                        </label>
                                        <input
                                            type="radio"
                                            className="rating-star-feedback"
                                            id="star2"
                                            name="rate"
                                            value="2"
                                        />
                                        <label htmlFor="star2" title="text">
                                            {" "}
                                            stars
                                        </label>
                                        <input
                                            type="radio"
                                            className="rating-star-feedback"
                                            id="star1"
                                            name="rate"
                                            value="1"
                                        />
                                        <label htmlFor="star1" title="text">
                                            {" "}
                                            star
                                        </label>
                                    </div>
                                    {/* <!--                        <div id="rating-star" className="pl-5">-->
<!--                            <i  className="fa fa-star"></i> <i className="fa fa-star"></i> <i className="fa fa-star"></i> <i className="fa fa-star"></i> <i className="fa fa-star"></i>-->
<!--                        </div>--> */}
                                </div>
                                <div>
                                    <p>
                                        Share Your Experience with{" "}
                                        <a
                                            href="#"
                                            className="orange giver-name"
                                        ></a>
                                    </p>
                                </div>
                                {/* <!--                    <textarea id="rating-comment" type="textarea" name="review" className="form-control" placeholder="Max 500 Words" style="height:auto !IMPORTANT;"></textarea>--> */}
                                <textarea
                                    id="rating-comment"
                                    type="textarea"
                                    name="review"
                                    className="form-control"
                                    placeholder="Max 500 Words"
                                    style={{ height: "auto !IMPORTANT" }}
                                ></textarea>
                                <div className="py-4 float-right">
                                    {" "}
                                    <button
                                        type="submit"
                                        className="btn btn-secondary font-weight-bold"
                                    >
                                        Submit Your Feedback
                                    </button>
                                </div>
                            </form>
                        </div>
                        <div className="col-md-4 box-shadow-only-hover hover-top profilebox col-xs-12 ">
                            <div className="card profile border rounded">
                                <div className="card-body ">
                                    <div className="d-flex flex-column align-items-center ">
                                        <div className="mt-3">
                                            <span>
                                                ID (
                                                <span className="giver-task-id"></span>
                                                )
                                            </span>
                                            <h5 className="blue task-detail"></h5>
                                            <ul className="tr-list job-meta list-unstyled job-social tr-list ul-color">
                                                <li className="giver-task-bio"></li>
                                            </ul>
                                            <div className="j-list">
                                                <ul className="tr-list job-meta list-unstyled job-social tr-list ul-color back-ck">
                                                    <li>
                                                        <i className="fa fa-exclamation"></i>{" "}
                                                        <span className="giver-job-status">
                                                            {" "}
                                                        </span>
                                                    </li>
                                                    <li>
                                                        <i className="fa fa-dollar"></i>
                                                        <span className="giver-job-amount"></span>{" "}
                                                    </li>
                                                    <li>
                                                        <i className="fa fa-calendar"></i>{" "}
                                                        <span className="giver-End-Date">
                                                            {" "}
                                                        </span>
                                                    </li>
                                                    <li>
                                                        <i className="fa fa-clock-o"></i>
                                                        <span className="giver-End-Time">
                                                            {" "}
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="">
                                                <ul className="list-unstyled friend-list border-bottom border">
                                                    <li className="active grey lighten-3  pl-1 pr-1">
                                                        <a
                                                            href="#"
                                                            className="d-flex pt-2 justify-content-between"
                                                        >
                                                            <img
                                                                src="./img/jobs/cl-1.png"
                                                                width="50"
                                                                height="50"
                                                                className="rounded-circle giver-task-img"
                                                                alt="avatar"
                                                            />
                                                            <div className="text-small">
                                                                <strong className="giver-name"></strong>
                                                                <p className="last-message text-muted ">
                                                                    <span className="orange giver-service"></span>
                                                                </p>
                                                            </div>
                                                            <div className="chat-footer pt-2">
                                                                <p className="text-smaller text-muted mb-0">
                                                                    <i className="fa fa-star"></i>
                                                                    <span className="giver-task-rating"></span>
                                                                </p>
                                                            </div>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}

export default ThankYou;
